import { render, staticRenderFns } from "./MasterVendor.vue?vue&type=template&id=f74d375c"
import script from "./MasterVendor.vue?vue&type=script&lang=js"
export * from "./MasterVendor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports